




































import { Component, Mixins, Prop, Watch, Emit } from "vue-property-decorator";
import { Point, Size, Rectangle, IPoint, ISize } from "../../../../../base/domain/drawing";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import { IFormatObjectEditable } from "../../../../domain/editableFormat";
import {
  ILocationPropertyEditable, instanceOfILocationPropertyEditable,
  ISizePropertyEditable, instanceOfISizePropertyEditable,
  instanceOfIRectangleCoordinateEditable,
  instanceOfIVectorCoordinateEditable,
} from "../../../../domain/editableFormat/properties";
import { IConfiguration } from "../../../../domain/configuration";
import { FormatPageStructureEditableMixin, CommonComponentsAccessibleMixin } from "../mixins";
import { default as FormatObjectDrawer } from "./FormatObjectDrawer.vue";

@Component({
  components: {
    FormatObjectDrawer,
  }
})
export default class FormatPageObjectMenu extends Mixins(ModelEditableMixin, FormatPageStructureEditableMixin, CommonComponentsAccessibleMixin) {
  @Prop({ default: 1 })
  scale: number;

  @Prop({ type: Function, default: (location: Point) => undefined as number })
  toObjectIndex: (location: Point) => number;

  get geometryProperties(): any {
    return this.menuLocation
      ? {
        position: "absolute",
        top: this.menuLocation.y - 10 + "px",
        left: this.menuLocation.x - 10 + "px",
      }
      : null;
  }

  get shouldShow(): boolean {
    return !!this.menuLocation
        // メニューのコンテンツが表示されてるかの情報がないので、サイズで判断する.閾値より小さければなしと判断する.
        && (FormatPageObjectMenu._emptyThresholdSize.width < this.size.width)
        && (FormatPageObjectMenu._emptyThresholdSize.height < this.size.height);
  }

  data(): any {
    return {
      previousMouseLocations: [] as Point[],
      source: null,
      lastSource: null,
      menuSize: new Size(0, 0),
      menuLocation: null,
      isObjectsPastable: false,
    };
  }
  previousMouseLocations: Point[];
  source: IFormatObjectEditable;
  lastSource: IFormatObjectEditable;
  menuSize: Size;
  menuLocation: Point;
  isObjectsPastable: boolean;

  $configuration!: IConfiguration;

  getObjectsPastable(): boolean {
    return this.getCommonComponents().getClipboardManager().hasClippedObjects();
  }

  copyObjects(): void {
    this.getCommonComponents().getClipboardManager().clipSelectedObjects();
  }

  pasteObjects(): void {
    const params = this.isQuestionnaireEditable
      ? { location: new Point(), index: this.toObjectIndex(this.menuLocation) }
      : { location: this.menuLocation, index: undefined };
    this.getCommonComponents().getClipboardManager().pasteObjects(params.location, params.index);
  }

  get isSourceHandling(): boolean {
    return !!this.source;
  }

  get isObjectsCopyable(): boolean {
    return this.hasSelectedObjects;
  }

  get shouldShowAlignableMenu(): boolean {
    return this.isSourceHandling && !this.isQuestionnaireEditable;
  }

  get isQuestionnaireEditable(): boolean {
    return this.$configuration.formatEditor.extensions.questionnaire.isEnable;
  }

  mounted(): void {
    // メニュー以外をクリックした場合クローズできるようwindowにイベントを追加
    window.addEventListener("pointerdown", () => this.closeMenu());
  }

  onMenuClick() {
    // 親のmousedownイベントでフォーカスが失われるトリガがあるため、親への通知を止めたうえでメニュークローズのトリガをクリックにも追加
    this.closeMenu();
  }

  handleMouseDownCaptured(source: IFormatObjectEditable, event: PointerEvent) {
    this.closeMenu();
    if (event.button === 2) {
      this.openMenu(event, source);
    }
  }

  handlePageMouseRightDowned(event: PointerEvent) {
    this.closeMenu();
    this.openMenu(event);
  }

  private openMenu(event: PointerEvent, source?: IFormatObjectEditable): void {
    const parentGeometry = (this.$parent.$el).getBoundingClientRect();
    this.menuLocation = (new Point(
      event.clientX + (this.$parent.$el).scrollLeft - parentGeometry.left,
      event.clientY + (this.$parent.$el).scrollTop - parentGeometry.top
    ))
    .multiply(1 / this.scale);
    if (!!source) {
      this.source = source;
      this.lastSource = source;
    }
    this.menuSize = new Size(FormatPageObjectMenu._emptyThresholdSize.width, FormatPageObjectMenu._emptyThresholdSize.height);  // 一旦非表示にする.表示されない閾値のサイズに一旦更新する.
    setTimeout(() => this.updateSize(source), 500);
    this.isObjectsPastable = this.getObjectsPastable();
  }

  private closeMenu(): void {
    this.source = null;
    this.menuLocation = null;
  }

  // サイズによるメニューのコンテンツ有無判定の閾値.(スタイル変更する場合は値に注意する事.)
  private static readonly _emptyThresholdSize = new Size(15, 15);

  private updateSize(source: IFormatObjectEditable): void {
    if (this.lastSource !== source) {
      return;
    }
    this.menuSize = new Size(FormatPageObjectMenu._emptyThresholdSize.width + 1, FormatPageObjectMenu._emptyThresholdSize.height + 1);  // 表示されるまではサイズが取れないので、表示される最低サイズに一旦更新しておく.
    this.$nextTick(() => {
      // サイズは表示してからじゃないと取れないのでここで更新.
      this.menuSize = this.getSize();
    });
  }

  getSize(): Size {
    return this.$refs.root
      ? new Size((this.$refs.root as HTMLDivElement).clientWidth, (this.$refs.root as HTMLDivElement).clientHeight)
      : new Size(0, 0);
  }

  get sourceRectangle(): Rectangle {
    if (instanceOfIRectangleCoordinateEditable(this.source)) {
      return new Rectangle(Point.from(this.source.location().getValue()), Size.from(this.source.size().getValue()));
    } else if (instanceOfIVectorCoordinateEditable(this.source)) {
      return Rectangle.from([
        Point.from(this.source.from().getValue()),
        Point.from(this.source.to().getValue()),
      ]);
    } else {
      return null;
    }
  }

  get isAlignable(): boolean {
    return (1 < this.selectedObjects.length)
        && !!this.sourceRectangle;
  }

  alignLeft(): void {
    this.alignSelecteObjectLocations(s => ({
      x: this.sourceRectangle.topLeft.x,
      y: s.location().getValue().y,
    }));
  }

  alignTop(): void {
    this.alignSelecteObjectLocations(s => ({
      x: s.location().getValue().x,
      y: this.sourceRectangle.topLeft.y,
    }));
  }

  private alignSelecteObjectLocations(toLocation: (source: ILocationPropertyEditable) => IPoint): void {
    if (!this.isAlignable) {
      return;
    }
    this.updateSelectedObjects(s => {
      if (!instanceOfILocationPropertyEditable(s)) {
        return false;
      }
      s.location().setValue(toLocation(s));
      return true;
    });
  }

  alignWidth(): void {
    this.alignSelectedObjectSizes(s => ({
      width: this.sourceRectangle.size.width,
      height: s.size().getValue().height,
    }));
  }

  alignHeight(): void {
    this.alignSelectedObjectSizes(s => ({
      width: s.size().getValue().width,
      height: this.sourceRectangle.size.height,
    }));
  }

  alignSize(): void {
    this.alignSelectedObjectSizes(s => ({
      width: this.sourceRectangle.size.width,
      height: this.sourceRectangle.size.height,
    }));
  }

  private alignSelectedObjectSizes(toSize: (source: ISizePropertyEditable) => ISize): void {
    if (!this.isAlignable) {
      return;
    }
    this.updateSelectedObjects(s => {
      if (!instanceOfISizePropertyEditable(s)) {
        return false;
      }
      s.size().setValue(toSize(s));
      return true;
    });
  }

  private updateSelectedObjects(update: (source: IFormatObjectEditable) => boolean): void {
    this.writePropertyWhenValid(s => {
      for (const object of this.selectedObjects) {
        const cloned = object.clone();
        if (update(cloned)) {
          s.updateObject(cloned);
        }
      }
    });
  }

  @Watch("shouldShow")
  onShouldShowUpdated(newValue: boolean, oldValue: boolean) {
    if (!newValue) {
      this.closed();
    }
  }

  @Emit()
  closed() {}
}
